export var MemberAuthenticationGrantType;
(function(MemberAuthenticationGrantType) {
    MemberAuthenticationGrantType[/**
     * Authenticate using a username or email, and a password.
     */ "Password"] = 'password';
    MemberAuthenticationGrantType[/**
     * Authenticate using a refresh token.
     */ "RefreshToken"] = 'refresh_token';
})(MemberAuthenticationGrantType || (MemberAuthenticationGrantType = {}));

//# sourceMappingURL=member-authentication-grant-type.js.map